import './index.css'

const GridNumbers = ({numbers, selectedPoints, selectPoint, currentPoint})=>{

    return(
        <div className="grid-numbers-container">
            {numbers?.map((number, index) => (
                <div onClick={() => selectPoint( prev => ({...prev, currentPoint: number}))} key={index} className={`grid-number ${currentPoint === number ? 'selected' : ''}`}>
                    {number}
                </div>
            ))}
        </div>
    )

}
export default GridNumbers